import { X } from "lucide-react";
import Image from "next/image";
import React from "react";
import { ExplanationPanelProps } from "../types";

const ExplanationPanel: React.FC<ExplanationPanelProps> = ({
  showExplanation,
  onClose,
  exerciseData,
}) => {
  if (!showExplanation) return null;

  return (
    <aside className="relative mt-6 rounded-lg border border-white/10 bg-[#1B1C22] p-4 md:p-5">
      <button
        onClick={onClose}
        className="absolute right-2 top-2 flex h-11 w-11 items-center justify-center rounded-lg text-white/55 transition-colors hover:bg-white/[0.06] hover:text-white"
        aria-label="Close explanation"
      >
        <X className="h-4 w-4" aria-hidden="true" />
      </button>
      <div className="space-y-4 pr-10">
        <div>
          <h3 className="mb-3 text-base font-semibold text-white">Why this answer works</h3>
          <div className="space-y-3 text-white/70">
            <div className="space-y-2">
              <p className="text-sm md:text-base">
                <strong className="text-white">Missing word:</strong> &quot;
                {exerciseData.correctAnswer}&quot;
              </p>
              {exerciseData.hint && (
                <p className="text-sm md:text-base">
                  <strong className="text-white">Word type:</strong> {exerciseData.hint}
                </p>
              )}
            </div>

            {exerciseData.explanation && (
              <div className="mt-3 rounded-lg border border-white/10 bg-[#15161B] p-3.5">
                <div className="mb-2 flex items-center gap-2">
                  <div className="relative flex h-5 w-5 shrink-0 items-center justify-center overflow-hidden rounded-full bg-white/10">
                    <Image
                      src="/ui/brand-kit/marks/chickytutor-face-mark-128.png"
                      alt=""
                      width={20}
                      height={20}
                      className="h-full w-full object-cover"
                    />
                  </div>
                  <span className="text-xs font-semibold uppercase tracking-wider text-[#FD954F]">
                    Tutor&apos;s Note
                  </span>
                </div>
                <p className="text-sm leading-relaxed text-white/80 md:text-base">
                  {exerciseData.explanation}
                </p>
              </div>
            )}
          </div>
        </div>
      </div>
    </aside>
  );
};

export default ExplanationPanel;
